import { useContext, useState, useEffect } from 'react'
import { createNewAffiliate } from '../../context/authContext/apiCalls'
import { AuthContext } from '../../context/authContext/AuthContext'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Typography } from '@material-ui/core'

import './signup.css'
const NewAffiliate = () => {
  const { isFetching, message, error, dispatch, user } = useContext(AuthContext)
  const [phoneValue, setPhoneValue] = useState()
  const [hideForm, setHideForm] = useState(false)

  const [postData, setPostData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: phoneValue,
    AffiliateID: '',
    Instagram: '',
    Occupation: '',
    isAdmin: false
  })

  const handleChange = (e) => {
    const { name, value } = e.target

    setPostData({ ...postData, [name]: value })
  }
  const handleSignUp = async (e) => {
    e.preventDefault()

    const data = {
      FirstName: postData.FirstName.trim(),
      LastName: postData.LastName.trim(),
      Email: postData.Email.trim(),
      Phone: phoneValue ? phoneValue : postData.Phone,
      AffiliateID: postData.AffiliateID.trim(),
      Instagram: postData.Instagram,
      Occupation: postData.Occupation,
      Status: false,
      isAdmin: false
    }

    await createNewAffiliate({ data }, dispatch)
  }
  useEffect(() => {
    if (message) {
      if (
        message.message.data.message !== 'Email or Affiliate ID exits' &&
        message.message.data.message !== 'User Email aldreay exits'
      ) {
        setHideForm(true)
      } else {
        alert(message.message.data.message)
        setHideForm(false)
      }
    }
  }, [message, user])
  return (
    <div className='wrapSignupPage'>
      <div className='login'>
        <div
          className='wrapperLogin'
          style={{ display: hideForm ? 'none' : 'inline-block' }}
        >
          <div className='wrapLogo'>
            <div className='userLogo'>
              <Typography
                className='logoMain'
                variant='h1'
                style={{ fontWeight: '500', fontSize: '30px' }}
              >
                NATIONAL LASER
              </Typography>
              <Typography
                className='logoSub'
                variant='h2'
                style={{ fontWeight: '100', fontSize: '20px' }}
              >
                INSTITUTE
              </Typography>
              <Typography
                className='slogan'
                variant='h6'
                style={{
                  fontWeight: '100',
                  fontSize: '15px',
                  fontStyle: 'italic'
                }}
              >
                20 Years of Excellence!
              </Typography>
            </div>
          </div>
          <h1 className='IntakeForm'>Affiliate Signup</h1>
          <form className='loginForm'>
            <div className='twoColumn'>
              <input
                type='text'
                placeholder='First Name'
                name='FirstName'
                className='loginInput'
                value={postData.FirstName || ''}
                onChange={(e) => handleChange(e)}
              />
              <input
                type='text'
                placeholder='Last Name'
                className='loginInput'
                name='LastName'
                value={postData.LastName || ''}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <PhoneInput
              disableCountryCode={true}
              placeholder='Enter phone number'
              value={postData.Phone}
              country={'us'}
              onlyCountries={['us']}
              masks={{ us: '(...) ...-....' }}
              onChange={(phone) => setPhoneValue(phone)}
            />

            <input
              type='text'
              placeholder='Email'
              className='loginInput'
              name='Email'
              value={postData.Email || ''}
              onChange={(e) => handleChange(e)}
            />
            <input
              type='text'
              placeholder='Instagram'
              name='Instagram'
              className='loginInput'
              value={postData.Instagram || ''}
              onChange={(e) => handleChange(e)}
            />
            <select
              type='text'
              placeholder='Occupation'
              name='Occupation'
              className='loginSelect'
              value={postData.Occupation || ''}
              onChange={(e) => handleChange(e)}
            >
              <option value=''>select Occupation</option>
              <option value='Cosmetic Injector'>Cosmetic Injector</option>
              <option value='Laser Tech'>Laser Tech</option>
            </select>

            <button
              className='loginButton'
              onClick={handleSignUp}
              disabled={isFetching}
            >
              Submit
            </button>
            {error ? 'Wrong email or password! Please try again!' : null}
          </form>
        </div>
        <div
          className='affiliateMessage'
          style={{ display: hideForm ? 'inline-block' : 'none' }}
        >
          <div className='affiliateMessageWrap'>
            <div className='wrapLogo'>
              <div className='userLogo'>
                <Typography
                  className='logoMain'
                  variant='h1'
                  style={{ fontWeight: '500', fontSize: '30px' }}
                >
                  NATIONAL LASER
                </Typography>
                <Typography
                  className='logoSub'
                  variant='h2'
                  style={{ fontWeight: '100', fontSize: '20px' }}
                >
                  INSTITUTE
                </Typography>
                <Typography
                  className='slogan'
                  variant='h6'
                  style={{
                    fontWeight: '100',
                    fontSize: '15px',
                    fontStyle: 'italic'
                  }}
                >
                  20 Years of Excellence!
                </Typography>
              </div>
            </div>
            <div className='affiliateMessageWrapText'>
              <p>
                Hi {postData.FirstName} {postData.LastName},
              </p>
              <p>Welcome to the National Laser Institute Affiliate Program!</p>

              <p>
                I’m so excited to have you on board. This is an amazing
                opportunity to share your aesthetic journey on social media and
                earn some great referral fees while doing what you love—showing
                off your passion through photos and videos.
              </p>

              <p>
                Keep an eye out for an email with your dashboard login and
                tracking link. I’m so grateful to have you as part of the NLI
                family!
              </p>
              <p className='sign'>
                Louis
                <br />
                CEO & Founder
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewAffiliate
